module.exports = __webpack_public_path__ + "static/media/036_027_16-03-08 BCV Brainstorm-1.35e358f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/036_027_16-03-08 BCV Brainstorm-1.png
// module id = 535
// module chunks = 0